import React from 'react';
import { Link } from 'react-router-dom'; // react-router-dom থেকে Link ব্যবহার করুন

const NotFoundPage = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        backgroundColor: '#f8f9fa', // হালকা ব্যাকগ্রাউন্ড
        color: '#343a40', // গাঢ় টেক্সট
        fontFamily: 'Arial, sans-serif',
        padding: '20px',
      }}
    >
      <h1
        style={{
          fontSize: '6rem',
          margin: '0',
          color: '#dc3545', // লাল রং, যা ত্রুটিকে বোঝায়
          fontWeight: 'bold',
        }}
      >
        404
      </h1>
      <h2
        style={{
          fontSize: '2rem',
          marginTop: '10px',
          marginBottom: '20px',
        }}
      >
        Page Not Found!
      </h2>
      <p
        style={{
          fontSize: '1.1rem',
          maxWidth: '600px',
          lineHeight: '1.6',
        }}
      >
        দুঃখিত, আপনি যে পৃষ্ঠাটি খুঁজছেন তা আমরা খুঁজে পাচ্ছি না। সম্ভবত লিঙ্কটি ভুল বা পৃষ্ঠাটি সরানো হয়েছে।
      </p>
      <div style={{ marginTop: '30px' }}>
        <Link
          to="/"
          style={{
            display: 'inline-block',
            padding: '12px 25px',
            backgroundColor: '#148f77', // নীল বাটন
            color: 'white',
            textDecoration: 'none',
            borderRadius: '5px',
            fontSize: '1rem',
            transition: 'background-color 0.3s ease',
            marginBottom:'15px'
          }}
          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#0056b3')}
          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#148f77')}
        >
          হোমপেজে ফিরে যান
        </Link>
        <Link
          to="/contact-us" // যদি আপনার কন্টাক্ট পেজ থাকে
          style={{
            display: 'inline-block',
            padding: '12px 25px',
            backgroundColor: '#6c757d', // ধূসর বাটন
            color: 'white',
            textDecoration: 'none',
            borderRadius: '5px',
            fontSize: '1rem',
            marginLeft: '15px',
            transition: 'background-color 0.3s ease',
          }}
          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#5a6268')}
          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#6c757d')}
        >
          আমাদের সাথে যোগাযোগ করুন
        </Link>
      </div>
      <div style={{ marginTop: '40px', fontSize: '0.9rem', color: '#6c757d' }}>
        <p>&copy; {new Date().getFullYear()} আপনার ওয়েবসাইট নাম। সর্বস্বত্ব সংরক্ষিত।</p>
      </div>
    </div>
  );
};

export default NotFoundPage;